import { PreclassTestResultType } from "./preclass_check";
import { PubsubErrorCodes, PubsubMessageType } from "./pubsub";

export enum DraggableItemType {
  DirectoryUser = "directory-user",
}

export enum KeyboardShortcutSignalType {
  None = "none",
  NextTimelineSegment = "next-timeline-segment",
  PreviousTimelineSegment = "previous-timeline-segment",
  RunConfetti = "run-confetti",
  ToggleAbsentStudents = "toggle-absent-students",
  ToggleInstructorNotes = "toggle-instructor-notes",
  ToggleMute = "toggle-mute",
  ToggleTalkTimeOverlay = "toggle-talk-time-overlay",
  ToggleTimer = "toggle-timer",
}

export enum LocalModalContentType {
  None = "none",
  AvPreferences = "av-preferences",
  BookmarkForm = "bookmark-form",
  BugReportForm = "bug-report-form",
  KeyboardShortcuts = "keyboard-shortcuts",
  KickOutWarning = "kick-out-warning",
  PreclassCheck = "preclass-check",
  Reactions = "reactions",
  TalkTime = "talk-time",
}

export type PreclassCheckResultType = {
  [key in PreclassTestResultType["name"]]?: PreclassTestResultType;
};

export type LocalSliceStateType = {
  chatTextAreaContent: string;
  chatTextAreaContentOverride: string;
  currentUserId: string;
  currentlyBackingUpPoll: string | null;
  flightMonitoringUrl: string | null;
  overlayError: string | null;
  hasNewChatMessages: boolean;
  hasStageChanged: boolean;
  keyboardShortcutSignal: KeyboardShortcutSignalType;
  localModalContent: LocalModalContentType;
  pubsubErrorCode: PubsubErrorCodes | null;
  pubsubMessage: PubsubMessageType | null;
  showInstructorNotes: boolean;
  sidebarPanel: SidebarPanelType;
  preclassCheckResults: PreclassCheckResultType;
  joinTimestamp: number | null;
};

export enum SidebarPanelType {
  None = "none",
  Breakouts = "breakouts",
  Captions = "captions",
  Chat = "chat",
  Timeline = "timeline",
  Directory = "directory",
  Polls = "polls",
  Resources = "resources",
}
